// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__2fyjW","logo":"style_logo__1t2zj","imgLogo":"style_imgLogo__2YEYm","links":"style_links__2DDZs"};